<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">
  <h6  class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Assets<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span> Service Notes<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Manage Service Notes </h6>
 
  <div class="container-fluid">

    <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

<div class="d-flex">
  <b-input-group size="sm" style="width: 225px;">
    <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
    </b-form-input>
    
</b-input-group>
<div style="margin-top: 11px;" class="ms-2" >
<span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
</div>

</div>


<div class="d-grid gap-2 d-md-flex justify-content-md-end">


<button  @click="CrmCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">  Create Service Notes</button>


</div>
</div>



<div v-if="isLoading" class="card bdr-rad2 mt-1 shadow p-2">
  <div class="card-body d-flex justify-content-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div v-else class="card bdr-rad2 mt-1 shadow p-2  ">
<div class="card-body ">
 

  <b-table responsive style="font-size: small;"  class=" table-hover "
      :items="crms"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
       head-variant="dark"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
      @filtered="onFiltered"
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>
      <template #cell(number)="row">
        {{ row.index + 1 === 10 ? currentPage * 10 : currentPage - 1 + row.index + 1 }}
       
        
      </template>

       <template #cell(file)="row">
     <img
                    :src="row.item.attach_file"
                    alt="Preview"
                    style="width: 60px; cursor: pointer;"
                    @click="showImage(row.item.attach_file)"
                  />
       
        
      </template>

      <template #cell(actions)="row">
      
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        
        <button @click="viewLoad(row.item.idServicelog)"  size="sm"  class=" mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def">
          View
        </button>
        <button  @click="viewUpdate(row.item.idServicelog)" size="sm"  class=" mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def">
         Update
        </button>
       
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
      </b-col>

      

  
    
      <b-modal
                  id="image-modal"
                  v-model="showImageModal"
                  size="md"
                  hide-footer
                  title="Image Preview"
                >
                  <img :src="currentImage" alt="Full Image" style="width: 100%;" />
                </b-modal>

  

</div>
</div>
</div>
<br><br>
</div>








</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
         showImageModal: false,
    currentImage: '',
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        crms:[],
        isLoading: true,
       
        fields: [
        { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'I_pcode', label: 'Accet Code', sortable: true, sortDirection: 'desc' },
          { key: 'i_pdescription', label: 'Accet Description', sortable: true, sortDirection: 'desc' },
          { key: 'comments', label: 'Comment', sortable: true,  },
          { key: 'file', label: 'File', sortable: true,  },
          { key: 'num_code', label: 'Code', sortable: true,  },
          { key: 'job_type', label: 'Job Type', sortable: true  },
          { key: 'created_date', label: 'Created Date', sortable: true  },
          { key: 'username', label: 'Created By', sortable: true  },
          { key: 'followup_date', label: 'Follow up Date', sortable: true  },
          { key: 'followusername', label: 'Follow up by', sortable: true  },
      
         
          
          // { key: 'actions', label: 'Actions',  }
        ],
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadIssue();


    },
methods : {

  loadIssue(id) {

this.filterOn = id;
  },

   showImage(imagePath) {
    this.currentImage = imagePath;
    this.showImageModal = true;
  },

  viewLoad(id){
    this.$router.push('/cmmscrm/view?id='+id);
  },
  viewUpdate(id){
    this.$router.push('/cmmscrm/update?id='+id);
  },
  CrmCreate(){
    this.$router.push('/cmmscrm/create');
  },

  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  async loadIssue() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/ciinventory/crmindex',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
         this.crms = data.crm;
        this.totalRows =  this.crms.length;
        this.isLoading = false;
      
    } catch (error) {
      console.log(error.response);
      this.isLoading = false;
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>
